import { render, staticRenderFns } from "./About-Us.vue?vue&type=template&id=0920ca86&scoped=true&"
import script from "./About-Us.vue?vue&type=script&lang=js&"
export * from "./About-Us.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0920ca86",
  null
  
)

export default component.exports